/**
 * @property ifShowSegmentAction {boolean}  if show segment action, default is true
 * @property ifHideSearch {boolean} if hide search bar.
 * @property ifFromDetail {boolean} if from detail.
 */
import React, { Component } from "react";
import Select from "react-select";
import Search from "material-ui/svg-icons/action/search";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { Typeahead } from "react-bootstrap-typeahead";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import { Row, Col } from "../../framework/Grid/";
import { isEmpty, isNil, map } from "lodash";
import moment from "moment";
import "./actionAndSearch.css";

class ActionAndSearch extends Component {
  constructor() {
    super();
    this.throttle = false;
    this.state = {
      stateValue: "",
      showDataLoadingDialog: false,
      open: false, // if open popout
      nameOpts: [{ label: "", value: "" }],
      selectOptions: [
        { label: "Edit Audience", value: 1 },
        { label: "Archive Audience", value: 2 },
        { label: "Download as a PDF", value: 3 },
        { label: "Download as a CSV File", value: 4 },
        { label: "Create Audience File", value: 5 },
      ],
      sourceType: "",
      sourceTypeOptions: [
        { label: "All", value: "" },
        { label: "Audience Builder", value: "AudienceBuilder" },
        {
          label: "Segment - Website Visitors",
          value: "SegmentWebsiteVisitors",
        },
        {
          label: "Segment - Audience at Scale",
          value: "SegmentAudienceAtScale",
        },
      ],
      selectedItem: [{ label: "", value: "" }], // record the selection of user in the input
      ifStartDownloadCSV: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedSegmentSetArray &&
      nextProps.selectedSegmentSetArray.length >= 2
    ) {
      this.setState({
        selectOptions: this.state.selectOptions.map(item => {
          item.disabled = !(item.label === "Archive Segment");
          return item;
        }),
      });
    } else {
      if (
        nextProps.selectedSegmentSetArray &&
        nextProps.selectedSegmentSetArray.length === 0 &&
        !this.props.ifFromDetail
      ) {
        this.setState({
          selectOptions: [
            { label: "Edit Audience", value: 1, disabled: true },
            { label: "Archive Audience", value: 2, disabled: true },
            // {label: "Download as a CSV File", value: 4, disabled: true},
            { label: "Create Audience File", value: 5, disabled: true },
          ],
        });
      } else {
        this.props.ifFromDetail
          ? this.setState({
              selectOptions: [
                {
                  label: "Edit Audience",
                  value: 1,
                  disabled: this.props.roleId === 5,
                },
                { label: "Archive Audience", value: 2 },
                { label: "Download as a PDF", value: 3 },
                { label: "Download as a CSV File", value: 4 },
                {
                  label: "Create Audience File",
                  value: 5,
                  disabled: this.props.roleId !== 1 && this.props.roleId !== 5,
                },
              ],
            })
          : this.setState({
              selectOptions: [
                {
                  label: "Edit Audience",
                  value: 1,
                  disabled: this.props.roleId === 5,
                },
                { label: "Archive Audience", value: 2 },
                // {label: "Download as a CSV File", value: 4, disabled: true},
                {
                  label: "Create Audience File",
                  value: 5,
                  disabled: this.props.roleId !== 1 && this.props.roleId !== 5,
                },
              ],
            });
      }
    }
  }
  transformArray(array) {
    let arr = [];
    map(array, item => {
      let str = "";
      let sub_str = "";
      let name = "";
      if (item.id === 605606) {
        let count = 0;
        map(item.attributes, attr => {
          count += attr.values.length;
          map(attr.values, v => {
            sub_str += `"${v.label}","${v.total}"\r\n`;
          });
        });
        str = `AUTO MAKE/MODEL (${count}),\r\n`;
        arr.push(str + sub_str + "\r\n");
      } else {
        name = item.name + ",\r\n";
        let result = name;
        map(item.attributes, attr => {
          str = `${attr.name}(${attr.values && attr.values.length}),"${
            attr.total
          }"\r\n`;
          map(attr.values, v => {
            sub_str += `"${v.label}","${v.total}"\r\n`;
          });
          result += str;
          result += sub_str;
          str = "";
          sub_str = "";
        });
        arr.push(result + "\r\n");
      }
    });

    return arr.join("");
  }
  generateGeoString() {
    const { rules_count } = this.props;
    let arr = [];
    map(rules_count, r => {
      let str = "";
      let sub_str = "";
      if (r.attributeId === 1 || r.attributeId === 3 || r.attributeId === 7) {
        let audienceCount = 0;
        map(r.counts, count => {
          sub_str += `${count.key},"${count.value}"\r\n`;
          audienceCount += count.value;
        });
        str = `${r.attributeName} (${r.counts.length}),"${audienceCount}"\r\n`;
        arr.push(str + sub_str + "\r\n");
      }
      if (r.attributeId === 90 || r.attributeId === 91) {
        const { segment_summary } = this.props;
        const rawData = JSON.parse(segment_summary.rawData);
        const { addressLabel, radius, driveTime } = rawData.plotted_values;
        if (r.attributeId === 91) {
          str = " Custom Radius";
        } else {
          if (radius && addressLabel) {
            str = radius + " MILE(S) FROM " + addressLabel;
          }
          if (driveTime && addressLabel) {
            str = driveTime + " HOUR(S) DRIVE FROM " + addressLabel;
          }
          str = str
            .replace(",USA", "")
            .replace(", USA", "")
            .replace("USA", "");
        }
        str = `Location,"${str}"\nAudience Size,"${r.counts[0].value}"`;
        arr.push(str + "\r\n");
      }
    });
    if (isEmpty(arr)) {
      return "";
    }
    return "Geography,\r\n" + arr.join("");
  }
  handleSourceTypeChange(value, e) {
    this.props.onSourceTypeChange(value.value);
    this.setState(
      {
        sourceType: value.value,
        selectedItem: [{ label: "", value: "" }],
        nameOpts: [],
      },
      () => {
        this.handleSearch();
      },
    );
  }
  handleActionChange(value, e) {
    switch (value.label) {
      case "Edit Audience":
        // this.setState({showDataLoadingDialog: true})
        if (this.props.selectedSegmentSetArray.length === 1) {
          // action edit segment from audience
          this.props.getSegmentWithRules(this.props.selectedSegmentSetArray[0]);
          this.props.segment_list_active.data.forEach(item => {
            if (item.id === this.props.selectedSegmentSetArray[0]) {
              this.props.selectedClientChanged(item.clientId);
            }
          });
        } else if (this.props.match) {
          // redirect to edit segment from detail
          this.props.getSegmentWithRules(this.props.segment_summary.id);
          this.props.selectedClientChanged(this.props.segment_summary.clientId);
        }
        break;
      case "Archive Audience":
        this.setState({
          open: true,
        });
        break;
      case "Download as a PDF":
        this.props.downloadAsPDF();
        break;
      case "Download as a CSV File":
        if (
          this.props.selectedSegmentSetArray.length === 1 ||
          this.props.ifFromDetail
        ) {
          this.setState({
            showDataLoadingDialog: true,
          });
          let newLine = window.navigator.msSaveOrOpenBlob ? "\r\n" : "\n";
          window.setTimeout(() => {
            if (
              this.props.list &&
              this.props.segment_summary !== undefined &&
              this.props.segment_summary.name
            ) {
              let csv_string = "";
              const {
                audience_total_count,
                segment_summary,
                parent_client,
              } = this.props;
              let segmentName = `Segment Name,${segment_summary.name}${newLine}`;
              let creteDate = `Creation Date,${moment(
                segment_summary.createdTime,
              ).format("DD-MMM-YY")}${newLine}`;
              let client = `Client,${
                segment_summary && isNil(parent_client)
                  ? segment_summary.clientName
                  : isNil(parent_client)
                  ? ""
                  : parent_client.name
              }${newLine}`;
              let businessUnit = `Business Unit,${
                parent_client ? segment_summary.clientName : ""
              }${newLine}`;
              let attributes = `Attributes Selected, ${segment_summary.rules.length}${newLine}`;
              let audience = `Audience, ${audience_total_count.total}${newLine}`;
              let reachByChannel = `Reach By Channel,${newLine}`;
              let email = `Email, ${audience_total_count.email}${newLine}`;
              let social = `Social, ${audience_total_count.social}${newLine}`;
              let display = `Display, ${audience_total_count.display}${newLine}`;

              csv_string += segmentName;
              csv_string +=
                creteDate +
                client +
                businessUnit +
                attributes +
                audience +
                reachByChannel +
                email +
                social +
                display;
              //  'Geography,\n' + location + audience + ',\n'
              csv_string += "\r\n";
              csv_string += this.generateGeoString();
              csv_string += "\r\n";
              csv_string += this.transformArray(this.props.list);
              if (window.navigator.msSaveOrOpenBlob) {
                csv_string = "\ufeff" + csv_string;
                let blob = new Blob([csv_string], {
                  type: "text/csv;charset=utf-8",
                });
                navigator.msSaveOrOpenBlob(
                  blob,
                  `${this.props.segment_summary.name}.csv`,
                );
              } else {
                csv_string =
                  "data:text/csv;charset=utf-8,\ufeff" +
                  encodeURIComponent(csv_string);
                //let encodeUri = encodeURI(csv_string);
                let link = document.createElement("a");

                link.setAttribute("href", csv_string);
                link.setAttribute(
                  "download",
                  `${this.props.segment_summary.name}.csv`,
                );
                document.body.appendChild(link);
                link.click();
              }
              this.setState({
                showDataLoadingDialog: false,
              });
            }
          }, 800);
        }
        break;
      case "Create Audience File":
        if (this.props.selectedSegmentSetArray.length === 1) {
          this.props.createAudienceFile();
        }
        if (this.props.ifFromDetail) {
          this.props.createAudienceFile();
        }
        break;
      default:
        break;
    }
  }

  handleKeywordChange(selectedItem) {
    if (selectedItem.length > 0 && selectedItem[0].label.length > 0) {
      this.setState({
        selectedItem,
      });
    } else {
      this.setState({
        selectedItem: [{ label: "", value: "" }],
      });
    }
  }
  inputChange(text) {
    if (this.props.client_info) {
      if (this.props.sourceType)
        this.props.searchByName({
          keyword: text,
          clientId: this.props.client_info.id,
          status: this.props.ifShowSegmentAction ? "Active" : "Archived",
          source: this.props.sourceType,
        });
      else {
        this.props.searchByName({
          keyword: text,
          clientId: this.props.client_info.id,
          status: this.props.ifShowSegmentAction ? "Active" : "Archived",
        });
      }
      if (
        this.props.searchByNameResult &&
        this.props.searchByNameResult.length > 0
      ) {
        let pars = [];
        this.props.searchByNameResult.forEach((item, index) => {
          let child = {
            label: item,
            value: index,
          };
          pars.push(child);
        });
        this.setState({
          nameOpts: pars,
        });
      } else {
        this.setState({
          nameOpts: [],
        });
      }
    }
  }
  handleSearch() {
    let paramsObj = {
      clientId: this.props.client_info.id,
      pageNumber: 1,
      status: this.props.ifShowSegmentAction ? "Active" : "Archived", // if ifShowSegmentAction is false use `Archive`
      order: "desc",
      sortColumn: this.props.sortColumn,
    };
    if (!isEmpty(this.props.sourceType)) {
      paramsObj["source"] = this.props.sourceType;
    }
    if (this.state.selectedItem[0].label.length > 0) {
      paramsObj.name = this.state.selectedItem[0].label;
    }
    this.props.getSegmentList(paramsObj);
  }
  handleCloseTips() {
    this.setState({
      open: false,
    });
  }
  handleConfirmArchive() {
    this.setState({
      open: false,
    });
    this.props.handleConfirmArchive();
  }
  optionRenderer(options) {
    return <span>{options.label}</span>;
  }
  render() {
    return (
      <MuiThemeProvider>
        <div className="segment-action-and-search clearfix">
          {/*this.props.ifShowSegmentAction && (
            <div className="selection">
              <span className="mr-20">
                <strong>Audience Action</strong>
              </span>
              <Select
                className="segment-sele"
                value={this.state.stateValue}
                clearable={false}
                placeholder="Please select"
                options={this.state.selectOptions}
                onChange={(value, e) => this.handleActionChange(value, e)}
                searchable={false}
                multi={false}
                id="actionInput"
              />
            </div>
          )*/}
          <div style={{ display: "flex", paddingTop: "20px" }}>
            <div style={{ flex: "1 1" }} className="source-type-selection">
              <span className="mr-20">
                <strong>Source Type</strong>
              </span>
              <Select
                value={this.props.sourceType}
                clearable={false}
                placeholder="Please select"
                options={this.state.sourceTypeOptions}
                onChange={(value, e) => this.handleSourceTypeChange(value, e)}
                searchable={false}
                multi={false}
                id="actionInput"
              />
            </div>
            {!this.props.ifHideSearch && (
              <div className="searching clearfix" style={{ flex: "1 1" }}>
                <label htmlFor="">Search</label>
                {/*<input type="text"/>*/}
                <Typeahead
                  key="city_search_box"
                  className="search-typeahead"
                  multiple={false}
                  options={this.state.nameOpts}
                  placeholder="Search by Audience Name"
                  onInputChange={text => this.inputChange(text)}
                  onChange={selectedItem =>
                    this.handleKeywordChange(selectedItem)
                  }
                />
                <span className="search-btn">
                  <Search
                    onClick={() => this.handleSearch()}
                    style={{
                      color: "#FFF",
                      maginTop: "6px",
                      fontWeight: "bolder",
                    }}
                  />
                </span>
              </div>
            )}
          </div>

          <Dialog
            modal={false}
            open={this.state.open}
            onRequestClose={this.handleClose}
            contentStyle={{ width: "39%" }}
          >
            <p
              style={{
                color: "black",
                textAlign: "center",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Click confirm to archive this audience
            </p>
            <div
              className="btns"
              style={{ textAlign: "center", marginTop: "1em" }}
            >
              <FlatButton
                label="CANCEL"
                backgroundColor="#FFF"
                labelStyle={{ color: "black" }}
                onClick={() => this.handleCloseTips()}
                hoverColor="#FFF"
                className="btn-aa-info mr-20"
              />
              <FlatButton
                label="ARCHIVE SEGMENT"
                backgroundColor="#DD0000"
                labelStyle={{
                  color: "#FFF",
                  padding: 0,
                  verticalAlign: "inherit",
                }}
                onClick={() => this.handleConfirmArchive()}
                hoverColor="#DD0000"
                className="btn-aa-warning"
              />
            </div>
          </Dialog>
          <Dialog
            open={this.state.showDataLoadingDialog}
            style={{ top: "-1.8em" }}
            overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
            modal={true}
          >
            <Row className="mt-20">
              <Col xs="7" sm="7" md="7" lg="7" className="text-right">
                <div>Downloading, please wait...</div>
              </Col>
              <Col xs="1" sm="1" md="1" lg="1">
                <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
              </Col>
            </Row>
          </Dialog>
        </div>
      </MuiThemeProvider>
    );
  }
}

ActionAndSearch.defaultProps = {
  ifShowSegmentAction: true,
  ifHideSearch: false,
  ifFromDetail: false,
};

export default ActionAndSearch;



// WEBPACK FOOTER //
// ./src/components/Segment/List/ActionAndSearch.jsx